import api from "../../config/client.axios.api";

export const getAllStoreApiRequest = async () => {
  const response = await api.get(`/store`);
  return response.data;
};
